export default {
  "name": "Twenty-Seven Paintings",
  "slug": "twenty-seven-paintings",
  "path": "/twenty-seven-paintings",
  "componentName" : "TwentySevenPaintings",
  "category": "Projects",
  "parent": false,
  "isPublic": true
}